export default __webpack_public_path__ + "static/media/clinic2.90c11b90.png";